export default [
    'funnel_widget',
    'anamnesis_widget',
]
